import { generateKeyBetween } from "fractional-indexing";
import { Block } from "../../types";


export function genKeyForPos(blocks: Block[], pos: number): string {
  const prevPosition = pos > 0 ? blocks[pos - 1].position : null;
  const nextPoisition = pos < blocks.length ? blocks[pos].position : null;

  return generateKeyBetween(prevPosition, nextPoisition);
}